// extracted by css-extract-rspack-plugin
export default {"overlay":"zbl4AA6N","modal":"k29nqylQ","icon":"zp0JVY8c","iconContainer":"QGQTNL28","message":"ATPFCfTQ"};